<div
  [ngStyle]="backgroundStyle()"
  class="flex flex-col gap-3 items-center justify-center p-(--avatarcard-padding) rounded-(--avatarcard-border-radius) shadow-(--avatarcard-shadow)"
>
  <div class="flex items-center">
    @for (avatar of config().avatars; track $index; let isFirst = $first) {
      <div
        [class]="
          'rounded-full border-2 border-(--avatarcard-avatar-border-color) ' +
          (isFirst ? '' : 'ml-(--avatarcard-avatar-overlap)')
        "
      >
        <app-dynamic
          componentName="Avatar"
          [props]="{
            config: avatar,
          }"
        />
      </div>
    }
  </div>
  @if (config().text; as text) {
    <app-dynamic
      componentName="DynamicText"
      [props]="{ config: text }"
    />
  }
</div>
